module.exports = __webpack_public_path__ + "assets/mobile_back-8f2844.svg";